import React from "react";
import axios from "services/axios";
import _ from "lodash";
import { Card, message, Spin, Row } from "antd";
import ApprovalInformation from "../../Component/Section/ApprovalInformation";
import NewCarInformation from "../../Component/Section/NewCarInformation";
import CustomerInformation from "../../Component/Section/CustomerInformation";
import Discount from "../../Component/Section/Discount";
import RequestSectionFinish from "../../Component/Section/RequestSectionFinish";

class NewCarFinalDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      newCar: {},
      request: [],
      visibleModalRequest: false,
      visibleModalDeal: false,
      visibleModalNoDeal: false,
    };
    this.formatRupiah = this.formatRupiah.bind(this);
    this.visibleModal = this.visibleModal.bind(this);
  }

  componentDidMount() {
    this.fetchNewCar(this.props.match.params.id);
    this.fetchReasonNoDeal();
  }

  // ************************* Function Fetch Data *************************//
  fetchNewCar(id) {
    this.setState({ isLoading: true });
    axios
      .get(`/approval/new-car/${id}`)
      .then(result => {
        this.setState({
          newCar: result.data.approvalNewCar,
          request: result.data.approvalRequestStatus,
          isLoading: false,
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        message.error("Gagal request data New Car");
      });
  }

  fetchReasonNoDeal() {
    axios
      .get(`/approval/reason-list`)
      .then(result => {
        this.setState({
          reasonNoDealList: result.data,
        });
      })
      .catch(err => {
        message.error("Gagal request reason no deal list");
      });
  }

  // ************************* Function Helper *************************//
  getValue(data, key, value) {
    let found;
    data = _.find(data, { [key]: value });
    if (data) {
      if (data.value) {
        found = data.value;
      } else if (data.price) {
        found = data.price;
      }
    }
    return found;
  }

  formatRupiah(number) {
    let data;
    if (number) {
      if (number !== "N/A") {
        data = `Rp.${number
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")},-`;
      } else {
        data = number;
      }
    } else {
      data = `Rp.0,-`;
    }
    return data;
  }

  // ************************* Function Open/Close Modal *************************//
  visibleModal(type, val) {
    switch (type) {
      case "Discount":
        this.setState({ visibleModalRequest: val, typeRequest: type });
        break;
      case "Deal":
        this.setState({ visibleModalDeal: val });
        break;
      case "No Deal":
        this.setState({ visibleModalNoDeal: val });
        break;
    }
  }

  render() {
    const { newCar, request } = this.state;
    const { NewCar } = newCar;
    return newCar.id ? (
      <Card title="New Car">
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <div id="ApprovalNewCarDetail">
            <ApprovalInformation approval={newCar} approvalType="New Car" />
            <Row>
              <NewCarInformation
                edit={false}
                newCar={NewCar}
                formatRupiah={this.formatRupiah}
              />
              <CustomerInformation newCar={newCar} />
            </Row>
            <Row>
              <Discount
                approvalType="New Car"
                carPrice={NewCar ? NewCar.otr : "N/A"}
                request={request}
                formatRupiah={this.formatRupiah}
              />
              <RequestSectionFinish
                approval={newCar}
                request={request}
                formatRupiah={this.formatRupiah}
              />
            </Row>
          </div>
        </Spin>
      </Card>
    ) : null;
  }
}

export default NewCarFinalDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/NewCar/Final/NewCarDetail.js